import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContentSection, PageWrap, SectionHeading } from '@vwfs-bronson/bronson-react'

import { Analytics } from '../../services/analytics'
import { documentTitle } from '../../services/common/format'

const ErrorPage = routeProps => {
  const { location } = routeProps
  let code = null
  if (location.state) {
    // eslint-disable-next-line prefer-destructuring
    code = location.state.code
  }

  const { t } = useTranslation()
  const errors = ['error:text1', 'error:text2', 'error:text3']
  const errorText = errors.map(error => {
    return (
      <React.Fragment key={error}>
        {t(error)}
        <br />
      </React.Fragment>
    )
  })

  React.useEffect(() => {
    document.title = documentTitle(t, 'error')
    Analytics.track({
      pageName: 'Error page',
      events: [
        {
          eventInfo: {
            eventType: 'Error',
            eventAction: 'Page not found',
          },
        },
      ],
      error: {
        errorCode: code,
        errorMessage: 'Page not found',
        errorCausingURL: location.pathname,
      },
      browserResolutionBreakpoint: window.innerWidth,
    })
    Analytics.page()
  }, [t, location.pathname, code])

  return (
    <ContentSection>
      <PageWrap>
        <SectionHeading number={2}>{t('error:heading')}</SectionHeading>
        <br></br>
        {errorText}
      </PageWrap>
    </ContentSection>
  )
}

export default ErrorPage
